import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/css/App.css';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { I18nProvider } from './i18n/I18n';
import { ToastProvider } from './components/ui/Toast';
import { ThemeProvider } from './components/ui/ThemeProvider';

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}>
    <ThemeProvider>
      <I18nProvider>
        <ToastProvider>
          <HashRouter>
            <Switch>
              <Route path={`/auth`} component={AuthLayout} />
              <Route path={`/admin`} component={AdminLayout} />
              <Redirect from='/' to='/admin' />
            </Switch>
          </HashRouter>
        </ToastProvider>
      </I18nProvider>
    </ThemeProvider>
  </GoogleOAuthProvider>,
  document.getElementById('root')
);
